import Vue from "vue";
import Vuex from "vuex";

import auth from "@/store/auth";
import project from "@/store/project";
import report from "@/store/report";
import resources from "@/store/resources";
import news from "@/store/news";
import calendar from "@/store/calendar";
import organization from "@/store/organization";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    breadcrumbs: []
  },
  mutations: {
    setBreadcrumbs(state, crumbs) {
      state.breadcrumbs = crumbs;
    },
    addCrumb(state, crumb) {
      state.breadcrumbs[state.breadcrumbs.length - 1].active = false;
      state.breadcrumbs.push(crumb);
    }
  },
  getters: {
    breadcrumbs: state => state.breadcrumbs || []
  },
  modules: {
    auth,
    project,
    report,
    resources,
    news,
    calendar,
    organization
  }
});

export default store;
